import React from 'react';
import { cn } from '../../lib/utils';

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Avatar({ className, children, size = 'md', ...props }: AvatarProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  return (
    <div
      className={cn(
        "relative inline-flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 overflow-hidden",
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
} 